module.exports = __webpack_public_path__ + "static/img/bg-jgpt-case-facilities.b7eaf80e.png";